require("./lastMovementsTable.scss");

const React = require("react");
const PropTypes = require("prop-types");
const PureRenderMixin = require("react-addons-pure-render-mixin");
const tableMovementsHelper = require("utilities/tableMovementsHelper");
const classNames = require("classnames");
const { OKTable } = require("commonsComponents/OKTable");
const { OKTableGroupHeader } = require("commonsComponents/OKTableGroupHeader");
const { formatText } = require("core/i18n").i18n;

class LastMovementsTable extends React.Component {
  constructor(props) {
    super(props);

    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }

  processRows(items, subgroup, shouldExpandFirstRow) {
    const {
      rowComponent,
      immFilter,
      expandedRowId,
      expandedRowComponent,
      expandFirstRow,
      id,
      onRowClick,
      notifyFirstRowId,
      charLimit,
      isExpandable,
      isCanceledAccount,
      immFlagBasedFeatures,
      isTinkAggregator,
    } = this.props;

    let tableRows = [];
    let rowIndex = 0;
    let isExpanded;

    // We need to use forEach, to eventually add new rows when click.
    items.forEach((item, index) => {
      let currentId = `${id}-${subgroup}-${rowIndex}`;
      isExpanded = currentId === expandedRowId;

      const rowProps = {
        id: currentId,
        key: index,
        immTransaction: item,
        originalIndex: index,
        isExpandable,
        isExpanded,
        onRowClick,
        charLimit,
        isCanceledAccount,
        immFlagBasedFeatures,
        isTinkAggregator,
      };

      if (shouldExpandFirstRow && expandFirstRow && index === 0) {
        rowProps.notifyFirstRowId = notifyFirstRowId;
        rowProps.isFirstRow = true;
      }

      let row = React.createElement(rowComponent, rowProps);
      tableRows.push(row);

      if (isExpanded) {
        row = React.createElement(expandedRowComponent, {
          key: `${index}expanded`,
          immFilter: immFilter,
          id: `${id}-${subgroup}-expanded`,
          immTransaction: item,
          originalIndex: index,
        });

        tableRows.push(row);
      }

      rowIndex++;
    });

    return tableRows;
  }

  processGroup(immTransactions, shouldExpandFirstRow) {
    let { columnsCount, isExpandable } = this.props;
    let tableSubsectionsGroup;

    if (isExpandable) {
      columnsCount++;
    }

    const groupHeaderClassName =
      this.props.groupHeaderClassName + ' last-movements-table__group-header';

    if (immTransactions) {
      tableSubsectionsGroup = immTransactions.entrySeq().map((entry, index) => {
        const key = entry[0];
        const items = entry[1];
        const mustExpandFirstRow = shouldExpandFirstRow && index === 0;

        if (items.size === 0) {
          return null;
        }

        let tableRows = this.processRows(items, key, mustExpandFirstRow);

        return (
          <tbody key={key} className="last-movements-table__body">
            <tr>
              <OKTableGroupHeader colSpan={columnsCount} className={groupHeaderClassName}>
                {key}
              </OKTableGroupHeader>
            </tr>
            {tableRows}
          </tbody>
        );
      });
    }

    return tableSubsectionsGroup;
  }

  render() {
    const {
      children,
      immTransactionsByOrder,
      immTransactionsById,
      groupByDate,
      className,
      id,
      expandFirstRow,
      immFilter,
    } = this.props;

    let recentItemsRows;
    let currentMonthItems;
    let currentYearItems;
    let oldYearItems;
    let allItemsRows;

    let classes = classNames('last-movements-table', className);

    let immTransactions;
    if (immTransactionsByOrder) {
      immTransactions = immTransactionsByOrder.map(transactionId =>
        immTransactionsById.get(transactionId)
      );
    }

    if (immTransactions && immTransactions.size > 0) {
      if (groupByDate) {
        // First we classify items in subgroups by date
        const { immRecentItems, immCurrentMonthItems, immCurrentYearItems, immOldYearItems } =
          tableMovementsHelper.classifyItemsByDate(immTransactions);

        // Expand first row checking if the group before is empty.
        const currentMonthKey = formatText('myMoneyTransactions-thisMonth');
        const expandFirstRecentItem = immRecentItems.count() !== 0;
        const expandFirstCurrentMonthItem =
          immCurrentMonthItems.get(currentMonthKey).count() !== 0 && !expandFirstRecentItem;
        const expandFirstCurrentYearItem =
          immCurrentYearItems.count() !== 0 &&
          !expandFirstCurrentMonthItem &&
          !expandFirstRecentItem;
        const expandFirstOldYearItem = !expandFirstCurrentYearItem;

        // Then, we process every groups to obtain how to render each row
        recentItemsRows = (
          <tbody className="last-movements-table__body">
            {this.processRows(immRecentItems, 'recents', expandFirstRecentItem)}
          </tbody>
        );

        currentMonthItems = this.processGroup(immCurrentMonthItems, expandFirstCurrentMonthItem);
        currentYearItems = this.processGroup(immCurrentYearItems, expandFirstCurrentYearItem);
        oldYearItems = this.processGroup(immOldYearItems, expandFirstOldYearItem);
      } else {
        const rows = this.processRows(immTransactions, 'allItems', expandFirstRow);
        allItemsRows = <tbody className="last-movements-table__body">{rows}</tbody>;
      }
    }

    return (
      <OKTable className={classes} id={id} immFilter={immFilter}>
        {children}
        {recentItemsRows}
        {currentMonthItems}
        {currentYearItems}
        {oldYearItems}
        {allItemsRows}
      </OKTable>
    );
  }
}

LastMovementsTable.propTypes = {
  immFilter: PropTypes.object,
  immTransactionsByOrder: PropTypes.object,
  immTransactionsById: PropTypes.object,
  groupByDate: PropTypes.bool,
  columnsCount: PropTypes.number,
  rowComponent: PropTypes.func,
  children: PropTypes.object,
  className: PropTypes.string,
  groupHeaderClassName: PropTypes.string,
  expandedRowId: PropTypes.string,
  expandedRowComponent: PropTypes.func,
  id: PropTypes.string.isRequired,
  onRowClick: PropTypes.func,
  isExpandable: PropTypes.bool,
  expandFirstRow: PropTypes.bool,
  notifyFirstRowId: PropTypes.func,
  charLimit: PropTypes.number.isRequired,
  isCanceledAccount: PropTypes.bool,
  immFlagBasedFeatures: PropTypes.object,
  isTinkAggregator: PropTypes.bool,
};

LastMovementsTable.defaultProps = {
  groupByDate: true,
  immFlagBasedFeatures: null,
  className: '',
  groupHeaderClassName: '',
  expandedRowId: '',
  onRowClick: function () {},
  isExpandable: true,
  expandFirstRow: false,
  notifyFirstRowId: function () {},
  isCanceledAccount: false,
};

module.exports = LastMovementsTable;
